import './previewOfferPage.scss';

import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import logo from '../../../assets/logo-default.svg';
import vehicleSUVSideView from '../../../assets/vehicle-suv-sideview-two.png';
import { Rate } from '../../../components/Rate/Rate';
import { inputEventHandler } from '../../../components/utils/inputEventHandler';
import useLeadChannelStore from '../../../store/leadChannelStore/useLeadChannelStore';
import useParameterStore from '../../../store/parameterStore/useParameterStore';
import usePreviewStore from '../../../store/previewStore/usePreviewStore';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import { locator } from '../../../testing/e2e-locator/locator';

export function Component(): JSX.Element {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const {
    computed: { primaryLogoURL },
  } = useLeadChannelStore();

  const {
    computed: { hasValidPreviewOffer, titleText },
  } = usePreviewStore();

  const { amount, apr, payment, term } = useParameterStore();

  const { handleSubmit } = useForm();

  const formSubmit = (): void => {
    navigate('/preview/activation');
  };

  useEffect(() => {
    if (!hasValidPreviewOffer) {
      navigate('/sign-up');
    }
  }, [hasValidPreviewOffer]);

  return (
    <div className="preview-offer-page">
      <ThemeProvider theme={theme}>
        <Box sx={theme.pageLayout}>
          <header data-testid={locator.pages.previewOffer.header.root}>
            <img alt={t('imageAlts.logo')} src={primaryLogoURL || logo} />
          </header>

          <main>
            <figure>
              <img
                alt={t('imageAlts.vehicleSUVSideView')}
                src={vehicleSUVSideView}
              />
            </figure>
            <form
              data-testid={locator.pages.previewOffer.form.root}
              noValidate
              onSubmit={handleSubmit(formSubmit)}
            >
              <div className="form-content">
                <h1 data-testid={locator.pages.previewOffer.form.h1}>
                  {titleText}
                </h1>
                <h2 data-testid={locator.pages.previewOffer.form.h2}>
                  {t('PreviewOfferPage.subtitle', {
                    amount: inputEventHandler.number.formatter(amount),
                  })}
                </h2>

                <div style={{ marginBottom: '4.5rem' }}>
                  <Rate
                    apr={apr}
                    monthlyPaymentAmount={payment}
                    term={term}
                    isEstimate
                  />
                </div>

                <LoadingButton
                  color="primary"
                  data-testid={locator.pages.previewOffer.form.submitButton}
                  loadingPosition="start"
                  startIcon={<></>}
                  type="submit"
                  variant="contained"
                  fullWidth
                >
                  {t('PreviewOfferPage.continue')}
                </LoadingButton>

                <p className="form-disclaimer">
                  {t('PreviewOfferPage.disclaimer')}
                </p>
              </div>
              <footer data-testid={locator.pages.previewOffer.footer.root}>
                {t('copyright', { year: new Date().getFullYear() })}
              </footer>
            </form>
          </main>
        </Box>
      </ThemeProvider>
    </div>
  );
}

Component.displayName = 'PreviewOfferPage';
